function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m2 2.21a1.68 1.68 0 1 1 1.68 1.7 1.68 1.68 0 0 1 -1.68-1.7zm.23 12.32v-9.35h2.9v9.35zm10.87 0v-4.53c0-1.08 0-2.48-1.51-2.48s-1.74 1.16-1.74 2.38v4.63h-2.85v-9.35h2.74v1.28a3 3 0 0 1 2.75-1.51c2.97 0 3.51 1.93 3.51 4.45v5.13z",
  fill: "#fff"
});

var SvgIconLkn = function SvgIconLkn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLkn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-lkn.88ef3bec.svg";
export { ForwardRef as ReactComponent };